import LineItemForm from "@/components/LineItemForm/LineItemForm";
import { LineItem } from "@/utils/types/types";
import { Modal } from "@mantine/core";

type CustomItemModalProps = {
  opened: boolean;
  onClose: () => void;
  onSave?: () => void | Promise<void>;
  cartId: string;
  lineItem?: LineItem;
};

export default function CustomItemModal({
  opened,
  onClose,
  onSave,
  cartId,
  lineItem,
}: CustomItemModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={lineItem ? "Edit Custom Item" : "Create Custom Item"}
      size="xl"
      zIndex={9000}
      styles={{ body: { padding: 0 } }}
    >
      <LineItemForm
        cartId={cartId}
        lineItem={lineItem}
        onSubmit={onSave ?? onClose}
      />
    </Modal>
  );
}
